export default "__VITE_ASSET__DbniFovE__"